// A fenced block in a note, markdown style: ```name on a line of its own, the
// content, and ``` closing it. `from`-`to` covers the fences, whole lines,
// and `contentFrom`-`contentTo` the text between them.
export interface Fenced {
  from: number;
  to: number;
  contentFrom: number;
  contentTo: number;
  content: string;
}

export const findFenced = (body: string, name: string): Fenced[] =>
  Array.from(
    body.matchAll(
      new RegExp(`^\`\`\`${name}[^\\S\\n]*\\n([\\s\\S]*?)^\`\`\``, 'gm'),
    ),
    m => {
      const contentFrom = m.index + m[0].indexOf('\n') + 1;
      const end = body.indexOf('\n', m.index + m[0].length);
      return {
        from: m.index,
        to: end === -1 ? body.length : end,
        contentFrom,
        contentTo: contentFrom + m[1].length,
        content: m[1],
      };
    },
  );
